import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    signatureData: null
};

const signatureSlice = createSlice({
    name: 'signature',
    initialState: initialState,
    reducers: {
        setSignatureData: (state, action) => {
            state.signatureData = action.payload;
        },
        removeSignatureData: (state) => {
            state.signatureData = null;
        }
    }
});

export const { setSignatureData, removeSignatureData } = signatureSlice.actions;
export default signatureSlice.reducer;
